<script setup>
import useGrid from "@/composables/useGrid";
import {inject, watch, computed} from "vue";
import TablePager from "@/components/TablePager.vue";
import SearchCompanyName from "@/components/customColumns/SearchCompanyName.vue";
import searchTypes from "@/constants/searchTypes";
import IRLScore from "@/components/customColumns/IRLScore.vue";
import SearchCompanyLocation from "@/components/customColumns/SearchCompanyLocation.vue";

const getStartupsIndexList = inject("getStartupsIndexList");
const searchQuery = inject("startupsSearchQuery");
const searchCategories = inject("selectedStartupsCategories");

const {gridParams, gridMethods, items, listLoaded} = useGrid(getFilteredStartups, 10, listUpdated);

const startupsCount = computed(() => {
    return gridParams.totalRowsCount;
});

watch([searchQuery, searchCategories], () => {
    gridMethods.resetList();
});

function getFilteredStartups(pageParams) {
    return getStartupsIndexList({
        query: searchQuery.value,
        categories: searchCategories.value,
    }, pageParams);
}


function listUpdated() {
    items.value = items.value.map(startup => ({
        ...startup,
        cropCategories: true,
    }));
}

function getCategories(row) {
    if (row.cropCategories) {
        return row.categories.slice(0, 3);
    } else {
        return row.categories;
    }
}

function initList() {
    gridMethods.loadIfNotLoaded();
}

defineExpose({
    initList,
    startupsCount
});
</script>

<template>
    <div class="main-table-wrapper main-table-wrapper--light">
        <template v-if="listLoaded">
            <template v-if="items.length">
                <table class="main-table">
                    <tbody>
                    <tr v-for="startup in items" :key="startup.id">
                        <td>
                            <SearchCompanyName
                                :column-data="startup.name"
                                :add-data="{
                                companyType: searchTypes.STARTUPS,
                            }"
                                :column-raw-data="startup"
                                :row-id="startup.id"
                            />
                        </td>
                        <td>
                            <IRLScore
                                :column-data="startup"
                            />
                        </td>
                        <td>
                            <SearchCompanyLocation
                                :column-data="startup.location"
                            />
                        </td>
                        <td>
                            <div v-if="startup.categories.length" class="tags-list tags-list--light">
                                <span
                                    v-for="category in getCategories(startup)"
                                    :key="category.id"
                                    class="tags-list__tag"
                                    :title="category"
                                >
                                    {{ category }}
                                </span>

                                <div v-if="startup.categories.length > 3" class="text-center">
                                    <a v-if="startup.cropCategories" class="link" @click="startup.cropCategories = false">+ {{ startup.categories.length - 3 }} more</a>
                                    <a v-else class="link" @click="startup.cropCategories = true">Show less</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <TablePager
                    :pages-count="gridParams.pagesCount"
                    :init-page="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                />
            </template>

            <div v-else class="no-data-message">
                <h4 class="heading4">No Startups</h4>
                <p>Try changing your search criteria</p>
            </div>
        </template>
    </div>
</template>

<style scoped>
.main-table .main-table__data {
    min-width: auto;
}

.tags-list {
    display: block;
}
</style>
